<div mat-dialog-title>
  <h1 style="display: flex;align-items: center;margin-top:-4px;padding-top:8px;">
    <mat-icon style="margin-left:-8px;margin-top:4px;margin-right:-2px;">bolt</mat-icon>
    {{ title }}
  </h1>
  <app-dialog-close-button layoutMode="float" (click)="close()"></app-dialog-close-button>
</div>
<div mat-dialog-content>
  <div
    style="display: flex;flex-direction: column;gap:10px;align-items: stretch;justify-content: stretch;cursor: default">
    <div style="display: flex;align-items: center">
      <span style="min-width:200px;">Original:</span>
      <div style="width:100%"></div>
      $<input
      value="{{ (data.originalPrice | currency)?.replace('$','') }}"
      style="max-width:150px;min-width:150px;margin-left:3px;padding:0 14px 0 0;text-align: right;"
      disabled></div>
    <div style="display: flex;align-items: center;font-weight: bold;color:#195f30">
      <span style="min-width:200px;">Override:</span>
      <div style="width:100%"></div>
      $<input
      autofocus
      [(ngModel)]="customPrice"
      (keyup.enter)="validateMaxValue($event.target.value);updateCustomPrice();"
      (blur)="formatAmount()"
      step="0.01"
      min="0"
      [max]="maxPrice"
      type="number"
      style="font-weight:bold;max-width:150px;min-width:150px;margin-left:3px;padding:0;text-align: right;"></div>
    <div *ngIf="maxPrice" style="margin-top:-5px;font-size:13px;color:#666;text-align: right">Max
      Amount: {{ (maxPrice | currency) }}
    </div>
  </div>
</div>
<div mat-dialog-actions style="display: flex;justify-content: center;gap:24px">
  <button
    mat-button style="flex-grow:2;margin:0;background: #7a4e4e;color:#fff;"
    (click)="removeCustomPrice()">Clear
    Override
  </button>
  <button
    mat-button
    type="submit"
    style="flex-grow:2;margin:0"
    (click)="updateCustomPrice()"
    [disabled]="!customPrice || !isValidNumber(customPrice) || (maxPrice && customPrice > maxPrice)">
    Update Override
  </button>
</div>
